import { render, staticRenderFns } from "./AdminView.vue?vue&type=template&id=45bf5279&scoped=true"
import script from "./AdminView.vue?vue&type=script&lang=ts"
export * from "./AdminView.vue?vue&type=script&lang=ts"
import style0 from "./AdminView.vue?vue&type=style&index=0&id=45bf5279&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bf5279",
  null
  
)

export default component.exports